import React, { useState, useEffect } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridFilterToolbarButton,
} from "@material-ui/data-grid";
import { Typography, Button, Tooltip, IconButton } from "@material-ui/core";
//icons
import {
  MonetizationOnRoundedIcon,
  PublishRoundedIcon,
} from "@material-ui/icons/";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import red from "@material-ui/core/colors/red";
import teal from "@material-ui/core/colors/teal";
import ShowAlert from "../../components/ShowAlert";
import renderCellExpand from "../../components/renderCellExpand";
import AppointmentsBottomNavigation from "../../components/staff/AppointmentsBottomNavigation";
import FindInPageIcon from "@material-ui/icons/FindInPage";
import useBrowserContextCommunication from "react-window-communication-hook";
// Services
import { appointmentService } from "../../services/appointmentService";
import { staffAppointmentService } from "../../services/staff/staffAppointmentService";
//Mapeo de clinicas
import { clinicsM } from "../../services/clinicsM";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parse, isMatch } from "date-fns";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { makeStyles } from "@material-ui/core/styles";
import { format } from "date-fns";
const AppointmentsTable = (props) => {
  const [hasToPay, setHasToPay] = useState({
    show: false,
    id: null,
    valueToPay: 0,
  });
  const [linkToTransferFiles, setLinkToTransferFiles] = useState("#");
  const [appointmentSelected, setAppointmentSelected] = useState(0);
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [communicationState, postMessage] = useBrowserContextCommunication(
    "DashboardStaffChanel"
  );
  const [rows, setRows] = useState(props.rows);
  const [rowsInitial, setRowsInitial] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const classes = useStyles();

  const [searchCita, setSearchCita] = useState("");
  const [searchPaciente, setSearchPaciente] = useState("");
  const [searchMedico, setSearchMedico] = useState("");
  const [searchEspecialidad, setSearchEspecialidad] = useState("");
  const [searchCuota, setSearchCuota] = useState("");
  const [searchCedula, setSearchCedula] = useState("");
  const [searchEstado, setSearchEstado] = useState("");
  const [inputClinicValue, setInputClinicValue] = useState("");

  const formattedDate = selectedDate
    ? format(selectedDate, "dd/MM/yyyy") // Formatea la fecha seleccionada
    : "";

  const clinicaEs14 = props.clinic?.cli_id === 14;

  //console.log("guillermo esta aqui ", rows.cita_num);

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridFilterToolbarButton />
        {/* <Tooltip title="Aprovar cita">
            <IconButton
              //disabled={!hasToPay.show}
              //onClick={() => handlePay()}
            >
              <CheckCircleIcon color="primary"/>
            </IconButton>
          </Tooltip>
          <Tooltip title="Cancelar cita">
            <IconButton
              //disabled={!(linkToTransferFiles !== "#")}
              //onClick={() => openTransferFileModal()}
            >
              <CancelIcon style={{ color: red[700] }} />
            </IconButton>
          </Tooltip> */}
      </GridToolbarContainer>
    );
  }

  const foramto = ({ row }) => {
    // Supongamos que el valor de la cuota moderadora es 4100
    const valorCuotaModeradora = row.value_to_pay;

    // Formatear el valor como moneda colombiana (COP)
    const formatoMoneda = new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(valorCuotaModeradora);

    return (
      <div>
        <strong>
          {row.paid === false ? (
            <div style={{ color: "red" }}>{formatoMoneda}</div>
          ) : (
            <div style={{ color: "teal" }}>{formatoMoneda}</div>
          )}
        </strong>
      </div>
    );
  };

  const columns = [
    {
      field: "sede",
      headerName: "Sede",
      width: 115,
      renderCell: (params) => (
        <div>
          {clinicaEs14 && params.row.sede.trim() === "001"
            ? "Itagüí"
            : clinicaEs14 && params.row.sede.trim() === "002"
            ? "Bello"
            : params.row.sede.trim()}
        </div>
      ),
      hide: !clinicaEs14,
    },

    /*  {
      field: "cita_num",
      headerName: "Número Cita",
      width: 115,
      renderCell: (params) => <div>{params.row.cita_num.trim()}</div>,
    }, */

    {
      field: "origen",
      headerName: "Origen",
      width: 145,
      renderCell: renderCellExpand,
    },

    {
      field: "cita_num",
      headerName: "Número Cita",
      width: 115,
      renderCell: renderCellExpand,
    },
    {
      field: "appointment_date",
      headerName: "Fecha",
      width: 115,
      renderCell: renderCellExpand,
    },
    {
      field: "appointment_time",
      headerName: "Hora",
      width: 115,
      filterable: false,
      renderCell: renderCellExpand,
    },
    {
      field: "Paciente",
      headerName: "Paciente",
      width: 250,
      renderCell: renderCellExpand,
      sortable: false,
      valueGetter: (params) => {
        const firstName = params.row?.paciente;
        const card_id = params.row?.info_dataRic?.identificacion;
        return `${firstName || ""} ${card_id || ""}`;
      },
    },
    {
      field: "medico",
      headerName: "Médico",
      width: 200,
      filterable: false,
      renderCell: renderCellExpand,
    },
    {
      field: "especialidad",
      headerName: "Especialidad",
      width: 200,
      filterable: false,
      renderCell: (params) => (
        <div>{params.row.info_dataRic?.especialidad.trim()}</div>
      ),
    },
    {
      field: "status",
      headerName: "Estado",
      width: 150,
      filterable: false,
      renderCell: renderCellExpand,
    },
    //{ field: 'value_to_pay', headerName: 'Cuota Moderadora', width: 100, filterable: false, renderCell: renderCellExpand },
    {
      field: "value_to_pay",
      headerName: "Cuota Moderadora",
      width: 250,
      renderCell: foramto,
    },

    /* 
   {params.row.paid === false? <div style="color: #000000de; ">{params.row?.cita_num}</div> : <div style="color: #000000de; ">{params.row?.cita_num}</div>}
   sortable: false,
      valueGetter: (params) => {
        const cita_num = params.row?.cita_num;
        const element = <h1 style={{ color: 'red' }}>Hello world</h1>
        return element
      },*/

    /* {
      field: 'Cancelar',
      headerName: 'Cancelar cita',
      width: 115,
      renderCell: (params) => (
        <Tooltip title="Cancelar cita">
            <IconButton
            disabled={params.row.estado==="AUTORIZADO"? true : false}
              onClick={() => handleCancelAppoinments(params)}
            >
              {params.row.estado==="AUTORIZADO"?  "": <CancelIcon style={{ color: red[700] }} />}
              
            </IconButton>
          </Tooltip>
      ),
    },
     {
      field: 'Aprobar',
      headerName: 'Aprobar',
      width: 100,
      renderCell: (params) => (
        <IconButton
          onClick={() => handleApprovalAppoinments(params)}
        >
          <CheckCircleIcon color="primary"/>
        </IconButton>
      ),
    },
    {
      field: 'Cancelar',
      headerName: 'Cancelar',
      width: 100,
      renderCell: (params) => (
        <IconButton
          onClick={() => handleCancelAppoinments(params)}
        >
          <CancelIcon style={{ color: red[700] }} />
        </IconButton>
      ),
    }, */
    /*
    {
      field: 'Contrato',
      headerName: 'Contrato',
      width: 150,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          startIcon={<FindInPageIcon />}
          onClick={() => handleSeeContratctButton(params)}
        >
        Ver
      </Button>
      ),
    },
    */
  ];

  const clinicsMaping = clinicsM.Maping();

  const handleCancelAppoinments = (params) => {
    const clinicIdCitapp = clinicsMaping[props.clinic.cli_id];
    const valueToEncrypt =
      "" +
      clinicIdCitapp +
      "|" +
      params.row.cerotram_user.card_id +
      `|${params.row.cerotram_user.card_id_type}|` +
      params.row.cita_num +
      "|Cancelacion por Citapp desde el correo|" +
      params.row.cerotram_user.user.username +
      "|" +
      params.row.appointment_date +
      "|" +
      params.row.appointment_time +
      "|" +
      params.row.paciente +
      "|" +
      params.row.medico;

    const urlCancelAppoinmentsModal =
      `https://ecodigital.portubien.co/citapp//citas/cancelarCitaCorreo/` +
      encrypt(valueToEncrypt) +
      "/0_tram/0_staff/" +
      params.row.cita_num;
    console.log("Url citapp ", urlCancelAppoinmentsModal);
    props.handleOpenCloseCancelAppoinmentsModal(urlCancelAppoinmentsModal);
  };

  function encrypt(valueToEncrypt) {
    const value = btoa(valueToEncrypt);
    //console.log("Valor encriptado =", value);
    return value;
  }

  const handleRowSelected = async (params) => {
    if (props.title === "Pendientes de autorización") {
      handleSeeContratctButton(params);
      setAppointmentSelected(params);
    }
  };

  const handleCheckBox = (newSelection) => {
    const newSet = new Set(newSelection.selectionModel);
    const lastSet = new Set(selectionModel);
    let newRowselected = [...newSet].filter((x) => !lastSet.has(x));
    if (newRowselected.length === 0)
      newRowselected = newSelection.selectionModel;
    if (newRowselected.length > 1) newRowselected = [];

    const params = { row: props.rows[parseInt(newRowselected[0])] };

    if (newRowselected.length === 1) {
      //console.log("params desde checkbox ",params);
      //handleRowSelected(params)
      setAppointmentSelected(appointmentSelected);
    } else {
      //setLinkToTransferFiles("#")
      //setHasToPay({show: false})
      setAppointmentSelected(appointmentSelected);
    }
    setSelectionModel(newRowselected);
  };
  //guillermo landazuri inico del modal
  const handleSeeContratctButton = (params) => {
    const ceroTramUser = params.row?.cerotram_user;
    props.setUserSelected(ceroTramUser);
    props.setCitaNumSelected(params.row.cita_num);
    props.handleOpenCloseUpdateInfoModal(ceroTramUser, params);
  };

  const handleApprovalAppoinments = async (params) => {
    props.setBackdropLoading(true);
    await staffAppointmentService.changeCeroTramAppointmentStatus(
      params.row?.cita_num,
      "aprobada"
    );
    postMessage({
      AppointmentStatusChanged: true,
    });
    props.setBackdropLoading(false);
  };

  const handleSwitchChange = (selected) => {
    props.handleSwitchChange(selected);
  };

  const handleSearchChange = (e) => {
    if (e.target.value !== "") {
      setRows((rowsInitial) =>
        rowsInitial.filter((row) =>
          Object.values(row).some(
            (value) =>
              typeof value === "string" &&
              value.toLowerCase().includes(e.target.value.toLowerCase())
          )
        )
      );
    } else {
      setRows(rowsInitial);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    //console.log("Paciente:", format(selectedDate, "dd/MM/yyyy"));

    if (
      searchCita != "" ||
      searchPaciente != "" ||
      searchMedico != "" ||
      searchEspecialidad != "" ||
      searchCuota != "" ||
      searchCedula != "" ||
      searchEstado != "" ||
      selectedDate != null
    ) {
      const filteredRows = rowsInitial.filter((row) => {
        const matchCita = !searchCita || row.cita_num.startsWith(searchCita);
        /*         const matchPaciente =
          !searchPaciente ||
          row.Paciente.toLowerCase().includes(searchPaciente.toLowerCase());
 */
        const matchPaciente =
          !searchPaciente ||
          (row.paciente &&
            row.paciente.toLowerCase().includes(searchPaciente.toLowerCase()));

        const matchCedula =
          !searchCedula ||
          (row.cerotram_user?.card_id &&
            row.cerotram_user?.card_id
              .toLowerCase()
              .includes(searchCedula.toLowerCase()));

        const matchfecha =
          !selectedDate ||
          (row.appointment_date &&
            row.appointment_date
              .toLowerCase()
              .includes(format(selectedDate, "dd/MM/yyyy").toLowerCase()));

        const matchMedico =
          !searchMedico ||
          row.medico.toLowerCase().includes(searchMedico.toLowerCase());

        const matchEspecialidad =
          !searchEspecialidad ||
          row.especialidad
            .toLowerCase()
            .includes(searchEspecialidad.toLowerCase());

        const matchCuota =
          searchCuota === "" || row.value_to_pay === searchCuota;

        //console.log("Row:", row);
        // console.log("Paciente:", selectedDate);

        const matchEstado = !searchEstado || row.status === searchEstado;
        //row.status.toLowerCase().includes(searchEstado.toLowerCase());

        return (
          matchCita &&
          matchPaciente &&
          matchMedico &&
          matchEspecialidad &&
          matchCuota &&
          matchCedula &&
          matchfecha &&
          matchEstado
        );
      });

      setRows(filteredRows);
    } else {
      setRows(rowsInitial);
    }
  };

  const handleFilterClear = (e) => {
    e.preventDefault();

    setSearchCita("");
    setSearchPaciente("");
    setSearchMedico("");
    setSearchEspecialidad("");
    setSearchCuota("");
    setSearchCedula("");
    setSearchEstado("");
    setSelectedDate(null);

    setRows(rowsInitial);
  };

  useEffect(() => {
    setRows(props.rows);
    setRowsInitial(props.rows);
  }, [props.rows]);

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        {props.title}
      </Typography>
      {alert.show && <ShowAlert {...alert} />}

      <form className={classes.form} noValidate>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={3}>
            <TextField
              name="cita"
              variant="outlined"
              required
              fullWidth
              id="cita"
              label="Número cita"
              autoFocus
              value={searchCita}
              onChange={(e) => setSearchCita(e.target.value)}
            />
          </Grid>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid item xs={12} sm={3}>
              <KeyboardDatePicker
                autoOk
                name="dob"
                inputVariant="outlined"
                variant="inline"
                id="dob"
                label="Fecha"
                format="dd/MM/yyyy"
                value={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                animateYearScrolling={true}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                style={{ width: "-webkit-fill-available" }}
              />
            </Grid>
          </MuiPickersUtilsProvider>
          <Grid item xs={12} sm={3}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="Paciente"
              label="Nombre Paciente"
              name="Paciente"
              value={searchPaciente}
              onChange={(e) => setSearchPaciente(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="Cedula"
              label="Cedula"
              name="Cedula"
              value={searchCedula}
              onChange={(e) => setSearchCedula(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="Medico"
              label="Medico"
              name="Medico"
              value={searchMedico}
              onChange={(e) => setSearchMedico(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="Especialidad"
              label="Especialidad"
              name="Especialidad"
              value={searchEspecialidad}
              onChange={(e) => setSearchEspecialidad(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="Cuota"
              label="Cuota Moderadora"
              name="Cuota"
              value={searchCuota}
              onChange={(e) => setSearchCuota(e.target.value)}
            />
          </Grid>
          {/*           <Grid item xs={12} sm={3}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="Estado"
              label="Estado"
              name="Estado"
              value={searchEstado}
              onChange={(e) => setSearchEstado(e.target.value)}
            />
          </Grid> */}

          <Grid item xs={12} sm={3}>
            <Autocomplete
              onChange={(event, newValue) => {
                // setClinicValue(newValue);

                if (newValue?.name) {
                  //console.log(newValue);
                  setSearchEstado(newValue?.name);
                } else {
                  console.log("nada");
                }
                //
              }}
              inputValue={inputClinicValue}
              onInputChange={(event, newInputValue) => {
                setInputClinicValue(newInputValue);
              }}
              id="clinics"
              options={estados}
              getOptionLabel={(estado) => estado?.name}
              renderInput={(params) => (
                <TextField {...params} label="Estado" variant="outlined" />
              )}
              name="esatdos"
            />
          </Grid>
        </Grid>

        <Grid container>
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              color="info"
              className={classes.submit}
              onClick={handleFilterClear}
            >
              Limpiar filtro
            </Button>
          </Grid>
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={handleFilter}
            >
              Aplicar filtro de busqueda
            </Button>
          </Grid>
        </Grid>
      </form>

      {/*   <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <div>
          <input
            type="text"
            placeholder="Buscar..."
            className="search"
            onChange={handleSearchChange}
            style={{ fontSize: "17px", paddingRight: "5px" }}
          ></input>
        </div>
      </div>
 */}
      <DataGrid
        autoHeight
        marginTop={2}
        rows={rows}
        columns={columns}
        pageSize={10}
        disableColumnMenu={true}
        loading={props.appointmentLoading}
        onRowClick={(params) => {
          handleRowSelected(params);
        }}
        //checkboxSelection={true}

        hideFooterSelectedRowCount
        onSelectionModelChange={(newSelection) => {
          handleCheckBox(newSelection);
        }}
        selectionModel={selectionModel}
      />
      <AppointmentsBottomNavigation handleSwitchChange={handleSwitchChange} />
    </React.Fragment>
  );
};

const estados = [
  { name: "PENDIENTE" },
  { name: "CANCELADO" },
  { name: "AUTORIZADO" },
  { name: "NO AUTORIZADO" },
];

const useStyles = makeStyles((theme) => ({
  paper: {
    paddingTop: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1, "auto", 1),
    alignItems: "center",
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    marginBottom: 50,
    marginRight: 20,
  },
  complete: {
    background: `url(http://www.clinicantioquia.com.co/wp-content/themes/heart/images/bg_corazon.jpg)`,
    //backgroundImage: `url(${Background})`,
    backgroundPosition: "center 10%",
    backgroundRepeat: "no-repeat",
    //height: '1000%',
    width: "100%",
    minWidth: "100vh",
    height: "100%",
    minHeight: "100vh",
    backgroundSize: "cover",
    //padding: theme.spacing(3, 9, 0),
    //borderRadius: '0px!important',
  },
  circle: {
    size: 60,
  },
}));
export default AppointmentsTable;
